import React from 'react';

const PermanentDisabilityDescription = () => (
  <va-details
    label="What we mean by permanent disability"
    class="vads-u-margin-bottom--4"
  >
    <p>
      For VA benefits purposes, a child has a permanent disability if they
      developed a physical or mental condition before they turned 18 that will
      last their whole life.
    </p>
    <p>
      A child with a permanent disability can’t support or care for themselves.
    </p>
  </va-details>
);

export default PermanentDisabilityDescription;
